import * as Types from '../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type TemplateRevisionsHistoryDialogTemplateRevisionFragment = { __typename: 'TemplateRevision', id: string, number: number, createdAt: string, createdBy?: { __typename: 'User', firstName?: string | null, lastName?: string | null } | null };

export type TemplateRevisionsHistoryDialogTemplateRevisionQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type TemplateRevisionsHistoryDialogTemplateRevisionQuery = { __typename: 'Query', templateRevisions: Array<{ __typename: 'TemplateRevision', id: string, number: number, createdAt: string, createdBy?: { __typename: 'User', firstName?: string | null, lastName?: string | null } | null } | null> };

export type TemplateRevisionsHistoryDialogDeleteTemplateRevisionMutationVariables = Types.Exact<{
  templateRevisionId: Types.Scalars['ID']['input'];
}>;


export type TemplateRevisionsHistoryDialogDeleteTemplateRevisionMutation = { __typename: 'Mutation', deleteTemplateRevision?: any | null };

export const TemplateRevisionsHistoryDialogTemplateRevisionFragmentDoc = gql`
    fragment TemplateRevisionsHistoryDialogTemplateRevision on TemplateRevision {
  id
  number
  createdBy {
    firstName
    lastName
  }
  createdAt
}
    `;
export const TemplateRevisionsHistoryDialogTemplateRevisionDocument = gql`
    query templateRevisionsHistoryDialogTemplateRevision($templateId: ID!) {
  templateRevisions(
    orderBy: {direction: desc, key: number}
    filter: {templateId: $templateId}
  ) {
    ...TemplateRevisionsHistoryDialogTemplateRevision
  }
}
    ${TemplateRevisionsHistoryDialogTemplateRevisionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplateRevisionsHistoryDialogTemplateRevisionGQL extends Apollo.Query<TemplateRevisionsHistoryDialogTemplateRevisionQuery, TemplateRevisionsHistoryDialogTemplateRevisionQueryVariables> {
    override document = TemplateRevisionsHistoryDialogTemplateRevisionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TemplateRevisionsHistoryDialogDeleteTemplateRevisionDocument = gql`
    mutation templateRevisionsHistoryDialogDeleteTemplateRevision($templateRevisionId: ID!) {
  deleteTemplateRevision(id: $templateRevisionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplateRevisionsHistoryDialogDeleteTemplateRevisionGQL extends Apollo.Mutation<TemplateRevisionsHistoryDialogDeleteTemplateRevisionMutation, TemplateRevisionsHistoryDialogDeleteTemplateRevisionMutationVariables> {
    override document = TemplateRevisionsHistoryDialogDeleteTemplateRevisionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }